export default __webpack_public_path__ + "static/media/logo.29629760.png";